import axiosClient from ".";
class BetRoundsPlayersStatsAPI {
  static getBetRoundsPlayersStats(data) {
    return axiosClient.get(`/bet_rounds_players_stats/${data.id}.json`);
  }
}
export default BetRoundsPlayersStatsAPI;
